import { ZinIcon } from '@tnl/zin-react'
import React from 'react'

export const getSelectValueFromEvent = (e: CustomEvent): string => (e.detail ?? (e as unknown as { target?: { value?: string } }).target?.value) as string

export const formatOptionValueOutput = (value: boolean | string | string[]) => {
  if (value === true) {
    return (
      <ZinIcon
        name="circle-check"
        size={16}
        className="mk-rental-options-modal__checkmark"
      />
    )
  }
  if (typeof value === 'string') {
    return value
  }
  if (Array.isArray(value)) {
    return value.map((str) => <p key={str}>{str}</p>)
  }
  return '-'
}
